import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const FETCH_VEHICLES = createRequestTypes('updateVehicle/FETCH_VEHICLES');
export const UPDATE_VEHICLE = createRequestTypes('updateVehicle/UPDATE_VEHICLE');
export const BULK_UPDATE_VEHICLE = createRequestTypes('updateVehicle/BULK_UPDATE_VEHICLE');
export const RESET_VEHICLE_DATA = createRequestTypes('updateVehicle/RESET_VEHICLE_DATA');

export const getOperatorVehicles = {
  request: (params) => createAction(FETCH_VEHICLES[REQUEST], { params }),
  success: (response, params) => createAction(FETCH_VEHICLES[SUCCESS], { response, params }),
  failure: (response) => createAction(FETCH_VEHICLES[FAILURE], { response }),
};

export const updateVehicle = {
  request: (params) => createAction(UPDATE_VEHICLE[REQUEST], { params }),
  success: (response, params) => createAction(UPDATE_VEHICLE[SUCCESS], { response, ...params }),
  failure: (response) => createAction(UPDATE_VEHICLE[FAILURE], { response }),
};

export const bulkUpdateVehicle = {
  request: (params) => createAction(BULK_UPDATE_VEHICLE[REQUEST], { params }),
  success: (response, params) => createAction(BULK_UPDATE_VEHICLE[SUCCESS], { response, ...params }),
  failure: (response) => createAction(BULK_UPDATE_VEHICLE[FAILURE], { response }),
};

export const resetVehicleData = {
  request: (params) => createAction(RESET_VEHICLE_DATA[REQUEST], {}),
};
